import React, { useState } from 'react';
import { useSelector } from "react-redux";
import Form from "../../Transactions/Transfer/Form";
import Controller from "../../Transactions/Transfer/Controller";
import Finish from "../../Transactions/Transfer/Finish";
import "./NewPayment.scss"

export default function NewPaymentComponent({ isMobile, mainProps, showSidebar }) {
    const { main, mainLoading, mainError } = mainProps;

    const [transactionStep, setTransactionStep] = useState("step-1");
    const [attentionData, setAttentionData] = useState("");
    const screenWidth = useSelector((state) => state?.common?.screenWidth);

    return (
        <>
            <div
                className="container-fluid bg-col transition-width"
                style={
                    !isMobile
                        ? {
                            width: showSidebar ? 'calc(100% - 332px)' : '100%',
                            marginLeft: 0,
                            marginRight: 'auto',
                            transition: showSidebar ? 'width 0.3s ease-in-out' : 'width 0.16s ease-in-out'
                        } : {}
                }
            >
                <div className="row p-3 reports-panel">
                    <h5 className="mb-5 mt-2" style={{ fontWeight: "500" }}>SINGLE TRANSFER / NEW PAYMENT</h5>
                    <p className='text-muted'>The account details are provided below. Kindly verify and complete all required fields to ensure the transfer is processed without any issues.</p>

                    <div className="border h-100 bg-white rounded">

                        <Controller
                            hasAccess={!(main?.user?.detail?.allow_transfer === false)}
                            transactionStep={transactionStep}
                        />

                        {main?.user?.detail?.allow_transfer === false ? (
                            <>
                                <div className="py-4 my-4">
                                    <div className="text-center mb-5">
                                        <h5 className="text-danger fw-bold">
                                            <i className="fa-solid fa-triangle-exclamation me-2"></i>
                                            Transfer Restrictions! Our Team will Reach Out Shortly.
                                        </h5>
                                    </div>
                                </div>
                            </>
                        ) : (
                            transactionStep === "step-1" || transactionStep === "step-2" || transactionStep === "step-3" ? (
                                <Form
                                    setAttentionData={setAttentionData}
                                    setTransactionStep={setTransactionStep}
                                    transactionStep={transactionStep}
                                    main={main}
                                />
                            ) : (
                                <Finish attentionData={attentionData} />
                            )
                        )}
                    </div>
                </div>
            </div >
        </>
    );
}